import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const handleExportPDF = async (ref) => {
    const element = ref.current;
    if (!element) return;
  
    // Save original styles
    const originalOverflowY = element.style.overflowY;
    const originalOverflowX = element.style.overflowX;
    const originalHeight = element.style.height;
    const originalWidth = element.style.width;
  
    try {
      // Expand to full content
      element.style.overflowY = 'visible';
      element.style.overflowX = 'visible';
      element.style.height = element.scrollHeight + 'px';
      element.style.width = element.scrollWidth + 'px';
  
      await new Promise((resolve) => setTimeout(resolve, 100)); // wait a bit
  
      const canvas = await html2canvas(element, {
        useCORS: true,
        scale: 2, // Higher scale = better quality
      });
  
      const imgData = canvas.toDataURL('image/png');
  
      const pdf = new jsPDF('l', 'pt', 'a4'); // 'l' = landscape
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
  
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
  
      const imgProps = {
        width: pdfWidth,
        height: (canvasHeight * pdfWidth) / canvasWidth, // Maintain aspect ratio
      };
  
      let position = 0;
      let heightLeft = imgProps.height;
  
      pdf.addImage(imgData, 'PNG', 0, position, imgProps.width, imgProps.height);
      heightLeft -= pdfHeight;
  
      while (heightLeft > 0) {
        position = heightLeft - imgProps.height;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgProps.width, imgProps.height);
        heightLeft -= pdfHeight;
      }
  
      pdf.save('chart.pdf');
    } catch (error) {
      console.error('Error exporting PDF:', error);
    } finally {
      // Restore original styles
      element.style.overflowY = originalOverflowY;
      element.style.overflowX = originalOverflowX;
      element.style.height = originalHeight;
      element.style.width = originalWidth;
    }
  };
  